import React, { useEffect } from "react";
import Tabs from "../../../components/common/Tabs";
import { tuitionViewTabsData } from "../../../config/tabsConfig";
import BreadCrumbs from "../../../components/common/BreadCrumbs/BreadCrumbs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchDropdownOptions } from "../../../store/slices/Tuition/tuitionApplySlice";
import { trackNavigation, trackCustomPageView } from '../../../services/analytics';

const TuitionViewDetailsTabList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { dropdownOptions } = useAppSelector((state) => state.tuitionApply);
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const createdDate = location.state?.createdDate;

  // Fetch dropdown options once at parent level to prevent multiple calls from child Form components
  useEffect(() => {
    if (Object.keys(dropdownOptions).length === 0) {
      dispatch(fetchDropdownOptions({ fieldName: 'all', applType: 'AT001' }) as any);
    }
  }, []);

  const formatDate = (date: string) => {
  if (!date) return '';
  return date.replaceAll('-', '/');
  };
  const handleBreadcrumbPrevious = () => {
    console.log('📊 Analytics: Navigate back to upload document');
    trackNavigation('tuition-details-tabs', 'tuition-upload-document', 'back');
    trackCustomPageView('status-documents');
    navigate("/tuition/upload-document");
  };

  return (
    <div className="lg:!px-[160px] min-h[67vh]mx-auto px-4 py-6 sm:mx-[20px]!">
      <BreadCrumbs
        previousPage="Back to view my details and upload documents"
        currentPage=""
        onPreviousClick={handleBreadcrumbPrevious}
      />

      <h1 className="h1 mt-8! mb-8! ">Viewing details</h1>
      <div className="flex items-center gap-4 text-base mb-8!">
        <p className="p3 -book"><b>Tuition reimbursement ID</b>:{id}</p>
        <p className="p3 -book"><b>Application date</b>:{formatDate(createdDate)}</p>
      </div>
      <Tabs tabs={tuitionViewTabsData} extraProps={{ applicationId: id }} />
    </div>
  );
};

export default TuitionViewDetailsTabList;